// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .block-ui-wrapper {
  background: rgba(255, 249, 249, 0.5) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/changelog/changelog.component.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD","sourcesContent":[":host ::ng-deep .block-ui-wrapper {\n  background: rgba(255, 249, 249, 0.5) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
